export default "__VITE_ASSET__43a2aefb__"